import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ResourcesTab = ({ pin }) => {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [key, setKey] = useState("");
  const [cap, setCap] = useState(1);

  const load = async () => {
    try {
      const { data } = await axios.post(`${API}/admin/resources/list`, { pin });
      setItems(data);
    } catch { toast.error("Ressourcen laden fehlgeschlagen"); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const add = async () => {
    if (!name.trim() || !key.trim()) return toast.error("Name und Schlüssel angeben");
    try {
      await axios.post(`${API}/admin/resources/create`, { pin, key: key.trim(), name: name.trim(), capacity: Math.max(1, Number(cap) || 1), active: true });
      setName(""); setKey(""); setCap(1); toast.success("Ressource angelegt"); load();
    } catch { toast.error("Anlegen fehlgeschlagen"); }
  };

  const patch = async (id, updates) => {
    try { await axios.patch(`${API}/admin/resources/${id}`, { pin, ...updates }); load(); }
    catch { toast.error("Speichern fehlgeschlagen"); }
  };
  const del = async (id) => {
    if (!window.confirm("Ressource löschen?")) return;
    try { await axios.delete(`${API}/admin/resources/${id}?pin=${pin}`); load(); }
    catch { toast.error("Löschen fehlgeschlagen"); }
  };

  return (
    <div data-testid="tab-resources" className="max-w-3xl">
      <h3 className="font-serif text-xl mb-4">Ressourcen</h3>
      <p className="text-sm text-muted-foreground mb-6">Kapazität = wie viele Termine gleichzeitig maximal möglich sind. Beispiel: 3 Pediküre-Sessel = 3 Pediküren zeitgleich buchbar.</p>

      <div className="border border-border divide-y divide-border">
        {items.map((r) => (
          <div key={r.id} data-testid={`resource-${r.key}`} className="flex items-center gap-3 p-3 flex-wrap">
            <div className="flex-1 min-w-[180px]">
              <Input value={r.name} onChange={(e) => setItems(items.map(x => x.id === r.id ? { ...x, name: e.target.value } : x))} onBlur={(e) => patch(r.id, { name: e.target.value })} />
              <span className="text-[10px] uppercase tracking-widest text-muted-foreground">{r.key}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xs text-muted-foreground">Kapazität</span>
              <input type="number" min="1" max="50" value={r.capacity}
                onChange={(e) => setItems(items.map(x => x.id === r.id ? { ...x, capacity: Number(e.target.value) } : x))}
                onBlur={(e) => patch(r.id, { capacity: Number(e.target.value) })}
                className="w-16 border border-border px-2 py-1 text-sm" />
            </div>
            <label className="flex items-center gap-2 text-sm cursor-pointer">
              <input type="checkbox" checked={r.active} onChange={(e) => patch(r.id, { active: e.target.checked })} /> aktiv
            </label>
            <button onClick={() => del(r.id)} className="text-foreground/40 hover:text-red-600 p-2"><Trash2 size={14} /></button>
          </div>
        ))}
        {!items.length && <p className="p-4 text-sm text-muted-foreground">Noch keine Ressourcen.</p>}
      </div>

      <div className="mt-6 border border-border p-4 space-y-3">
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Ressource hinzufügen</p>
        <div className="grid sm:grid-cols-3 gap-2">
          <Input placeholder="Name (z.B. Wimpernliege)" value={name} onChange={(e) => setName(e.target.value)} />
          <Input placeholder="Schlüssel (z.B. lash_couch)" value={key} onChange={(e) => setKey(e.target.value)} />
          <Input type="number" min="1" placeholder="Kapazität" value={cap} onChange={(e) => setCap(e.target.value)} />
        </div>
        <button data-testid="resource-add-btn" onClick={add} className="flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2 text-sm">
          <Plus size={14} /> Hinzufügen
        </button>
      </div>
    </div>
  );
};
